module.exports = __webpack_public_path__ + "static/img/tit4.e336d273.png";